import { render, staticRenderFns } from "./messageGroupUsers.vue?vue&type=template&id=3fa8cf56&"
import script from "./messageGroupUsers.vue?vue&type=script&lang=js&"
export * from "./messageGroupUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports